import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConfirmationFR from '../images/ConfirmationFR.svg';
import ConfirmationEN from '../images/ConfirmationEN.svg';
import config from 'config';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export const RegisterConfirmation = (): any => {
  const { t, i18n } = useTranslation('component');
  const navigate = useNavigate();

  const commerceURL =
    (config.COMMERCE_URL as string).replace('{lang}', '') + `/${i18n.resolvedLanguage}/my-account/dashboard`;

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = commerceURL;
    }, 5000);

    return () => clearTimeout(timer);
  }, [commerceURL, navigate]);

  return (
    <Card sx={{ my: '24px' }}>
      <CardMedia component="img" image={i18n.resolvedLanguage == 'fr' ? ConfirmationFR : ConfirmationEN} />
      <CardContent sx={{ textAlign: 'center', my: 2 }}>
        <Typography variant="title">{t('RegisterConfirmation.finalTitle')}</Typography>
        <Typography sx={{ mt: '16px' }}>{t('RegisterConfirmation.finalInfo')}</Typography>
      </CardContent>
    </Card>
  );
};
